import { faCheck, faMinus } from '@fortawesome/pro-regular-svg-icons';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import CustomCheckbox from './CustomCheckbox';

const SelectAllCheckbox = ({
  checkState,
  formApi,
  label,
  onChange,
  selectAllField,
}) => {
  const icon = checkState === 'mixed' ? faMinus : faCheck;
  useEffect(() => {
    if (checkState || checkState === 'mixed') {
      formApi.setValue(selectAllField, true);
    } else {
      formApi.setValue(selectAllField, false);
    }
  }, [checkState, formApi, selectAllField]);

  return (
    <CustomCheckbox
      aria-checked={checkState}
      className="min-h-8" // Make sure even a blank label maintains height
      field={selectAllField}
      icon={icon}
      onChange={onChange}
    >
      {label}
    </CustomCheckbox>
  );
};

SelectAllCheckbox.defaultProps = {
  checkState: false,
};

SelectAllCheckbox.propTypes = {
  checkState: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['mixed'])]),
  formApi: PropTypes.shape({
    setValue: PropTypes.func.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectAllField: PropTypes.string.isRequired,
};

export default SelectAllCheckbox;
